export default {

    /** 共通 **/
    //allErrors: {},

//    listObj: {},
//    listObjKeep: {},
//    // 0:waiting 1:loading 2:success 3:failed
//    listObjLoadStatus: 0,
//    // 0:waiting 1:loading 2:success 3:failed
//    listObjSeeMoreLoadStatus: 0,

    point: {},
    // 0:waiting 1:loading 2:success 3:failed
    pointLoadStatus: 0,

    /** 招待情報取得 **/
    inviteInfo: {},
    // 0:waiting 1:loading 2:success 3:failed
    inviteInfoLoadStatus: 0,

    companys: {},
    // 0:waiting 1:loading 2:success 3:failed
    companysLoadStatus: 0,

    // 0:waiting 1:loading 2:success 3:failed
    delCompanyStatus: 0,

    currentCompany: "",
    // 0:waiting 1:loading 2:success 3:failed
    addCompanyStatus: 0,

    companyOperat: "",
    // 0:waiting 1:loading 2:success 3:failed
    saveCompanyInfoStatus: 0,

    // 0:waiting 1:loading 2:success 3:failed
    shareInviteCodeStatus: 0,

    companyDetail: {},
    // 0:waiting 1:loading 2:success 3:failed
    companyDetailLoadStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    companyInviteDetailChangeStatus: 0,

    techLevel: {},
    // 0:waiting 1:loading 2:success 3:failed
    techLevelLoadStatus: 0,

    // 招待済み友達情報
    techChild: {},
    // 0:waiting 1:loading 2:success 3:failed
    techChildLoadStatus: 0,

    /** 履歴書一覧 **/
    techResume: {},
    techResumeLoadStatus: 0,

    techResumeHasChangeForInputBarStatus: 0,

    /** 履歴書配信Flg更新 **/
    changeTechResumeMailFlg: {},
    changeTechResumeMailFlgStatus: 0,

    /** 受信日最新化  **/
    updateTechResumeRecentInDay: {},
    updateTechResumeRecentInDayStatus: 0,

    /** 履歴書削除  **/
    deleteTechResumeStatus: 0,

    /** 履歴書詳細 **/
    resumeInfo: {},
    // create/create_confirm/show/edit/edit_confirm
    resumeOperat: "",
    // 0:waiting 1:loading 2:success 3:failed
    saveResumeInfoStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    resumeInfoLoadStatus: 0,

    latestPointInfo: {},
    // 0:waiting 1:loading 2:success 3:failed
    latestPointInfoLoadStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    makePointStatus: 0,

    /** 個人画面 **/
    personInfo: {},
    personInfoLoadStatus: 0,

    identityOkStatus: 0,
    identityNgStatus: 0,

    /** 月明細 **/

    payStatusChangeItem: {},
    payStatusChangeStatus: 0,


}
